import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "bi bi-info-circle-fill text-info ms-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  if: "item.percentUniverseMaxCount"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "border-bottom mb-3" }
const _hoisted_12 = { class: "mb-3 row" }
const _hoisted_13 = { class: "col-sm-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-9" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-3" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = { class: "col-3" }
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = { class: "mb-3 mt-3 row" }
const _hoisted_26 = { class: "col-sm-9" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "row mb-3 align-items-center" }
const _hoisted_31 = { class: "col-md-3 form-check" }
const _hoisted_32 = { class: "col-sm-4" }
const _hoisted_33 = { class: "row mb-3 align-items-center" }
const _hoisted_34 = { class: "col-md-3 form-check" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "col-sm-4" }
const _hoisted_37 = { class: "input-group" }
const _hoisted_38 = { class: "row mb-3" }
const _hoisted_39 = { class: "col-sm-4" }
const _hoisted_40 = { class: "row mb-3" }
const _hoisted_41 = { class: "col-sm-4" }

import {BTableColumn} from "../BTable/BTable.types";
import TextInput from "../Fields/TextInput.vue";
import {computed, onMounted, reactive, ref, watch} from "vue";
import {useOffenseStore} from "@/stores/offenseStore";
import {useAuditJobStore} from "@/stores/auditJobStore";
import {AuditJobCreate, Audit} from "@/audit.types";
import {debounce} from "vue-debounce";
import {number, object, date} from "yup";
import {useFormValidation} from "../../validation";
import BGrid from "../BGrid/BGrid.vue";
import {convertToUTC} from "@/utils";
import {BInput, BDatePicker} from "./../Fields";
import {FormModal} from "../Misc";

import {useConfirmDialog} from "@/composable/useConfirmDialog";
import {storeToRefs} from "pinia";

export default /*@__PURE__*/_defineComponent({
  __name: 'AuditJobs',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

var updateData = debounce(() => getData(), "15000ms");
const {confirm} = useConfirmDialog();

const props = __props;

const auditJob = ref<AuditJobCreate>({
    auditId: null,
    startMonth: props.audit.startMonth,
    endMonth: props.audit.endMonth,
    incidentTypes: [],
    offenseTypes: [],
    sampleSize: null,
    measureType: 0,
    percentUniverse: null,
    percentUniverseMinCount: 0,
    percentUniverseMaxCount: 50,
} as AuditJobCreate);

const schema = computed(() =>
    object<AuditJobCreate>({
        startMonth: date().required().label("Start Month").min(props.audit.startMonth),
        endMonth: date()
            .required()
            .label("End Month")
            .test(
                "maxDate-validation",
                `Start Month must be no later than ${props.audit.endMonth}`,
                async (endMonth) => {
                    var e = convertToUTC(new Date(props.audit.endMonth));
                    e.setMonth(e.getMonth() + 1);
                    return e >= endMonth;
                }
            )

            .when("startMonth", (startMonth, schema) => {
                if (auditJob.value.startMonth) {
                    const dayAfter = new Date(auditJob.value.startMonth.getTime() + 86400000);
                    return schema.min(dayAfter, "End month has to be no earlier than start month");
                }
                return schema;
            }),
        sampleSize: number()
            .nullable()
            .transform((value) => (isNaN(value) ? undefined : value))
            .when("measureType", {
                is: 0,
                then: (schema) => {
                    return schema.required().min(1);
                },
            })
            .label("Sample Size"),
        percentUniverse: number()
            .nullable()
            .transform((value) => (isNaN(value) ? undefined : value))
            .when("measureType", {
                is: 1,
                then: (schema) => {
                    return schema.required().min(1);
                },
            })
            .label("Percent of Universe"),
        percentUniverseMinCount: number()
            .nullable()
            .transform((value) => (isNaN(value) ? undefined : value))
            .min(0)
            .label("Min Count"),
        percentUniverseMaxCount: number()
            .nullable()
            .transform((value) => (isNaN(value) ? undefined : value))
            .when("measureType", {
                is: 1,
                then: (schema) => {
                    return schema.required().min(1);
                },
            })
            .when("percentUniverseMinCount", ([percentUniverseMinCount], schema) =>
                percentUniverseMinCount > 0 ? schema.moreThan(auditJob.value.percentUniverseMinCount!) : schema
            )
            .label("Max Count"),
    })
);

watch(
    () => auditJob.value.incidentTypes,
    async () => {
        await offenseStore.list(auditJob.value.incidentTypes.join(","));
    }
);

const auditJobStore = useAuditJobStore();
const {loading} = storeToRefs(auditJobStore);
const offenseStore = useOffenseStore();

const canSelectIncidents = computed(() => props.runAudits && props.audit.status != "Closed");
const canDelete = function (item) {
    return item.status == "Queued";
};

const columns = reactive<BTableColumn[]>([
    {
        key: "job-id",
        text: "Job #",
        sortable: false,
        value: (item) => item["id"],
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["status"],
    },
    {
        key: "dateRange",
        text: "Date Range",
        sortable: false,
        value: (item) => item,
    },
    {
        key: "incidentTypes",
        text: "Incident Groups",
        sortable: false,
        value: (item) => item["incidentTypes"],
    },
    {
        key: "offenseTypes",
        text: "Offense",
        sortable: false,
        value: (item) => item["offenseTypes"],
    },
    {
        key: "sampleSize",
        text: "Sample Size",
        sortable: false,
        value: (item) => item["sampleSize"],
    },
    {
        key: "incidents-count",
        text: "Incidents Selected",
        sortable: true,
        value: (item) => item["incidentsCount"],
    },
    {
        key: "actions",
        text: "",
        sortable: false,
        value: (item) => 2,
    },
]);

const {handleSubmit, errors, resetValidation} = useFormValidation();

const createJob = async () => {
    if (await handleSubmit(schema.value, auditJob.value)) {
        auditJob.value.auditId = props.id;
        await auditJobStore.create(auditJob.value);
        hideCreateEditor();
        await getData();

        auditJob.value = {
            sampleSize: null,
            incidentTypes: [],
            offenseTypes: [],
            measureType: 0,
            percentUniverseMinCount: 0,
            percentUniverseMaxCount: 50,
        } as unknown as AuditJobCreate;
    }
};
const canRunJob = ref(false);
const isShowCreateEditor = ref(false);
const showCreateEditor = () => {
    resetValidation();
    isShowCreateEditor.value = true;
    initDates();
};
const hideCreateEditor = () => {
    isShowCreateEditor.value = false;
};

const runJob = async (id: number) => {
    await auditJobStore.run(id);
};

const deleteJob = async (id: number) => {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        auditJobStore.deleteItem(id);
        await getData();
    }
};

const getData = async () => {
    await auditJobStore.list(props.audit.id);
    await updateData();
};
const startMonth = ref();
const endMonth = ref();

watch(startMonth, (newStartMonth) => {
    if (newStartMonth) {
        auditJob.value!.startMonth = convertToUTC(new Date(newStartMonth.year, newStartMonth.month, 1));
    }
});

watch(endMonth, (newEndMonth) => {
    if (newEndMonth) {
        auditJob.value!.endMonth = convertToUTC(new Date(newEndMonth.year, newEndMonth.month + 1, 0));
    }
});
onMounted(async () => {
    await getData();

    initDates();
});

function initDates() {
    let date = convertToUTC(new Date(props.audit.startMonth));

    startMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };

    date = convertToUTC(new Date(props.audit.endMonth));

    endMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Jobs", -1)),
      _createVNode(BGrid, {
        caption: "List of jobs",
        tableOptions: _unref(auditJobStore).tableOptions,
        filterableFields: _unref(auditJobStore).filterableFields,
        filterOptions: _unref(auditJobStore).filterOptions,
        onOptionChange: getData,
        items: _unref(auditJobStore).items,
        columns: columns,
        loading: _unref(auditJobStore).loading,
        "show-filter": false,
        "show-paging": false
      }, {
        beforeFilter: _withCtx(() => [
          (canSelectIncidents.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showCreateEditor()), ["prevent"]))
              }, " Select Incidents "))
            : _createCommentVNode("", true)
        ]),
        "cell.incidentNumber": _withCtx(({item, column}) => [
          _createElementVNode("span", null, _toDisplayString(item.incidentNumber), 1)
        ]),
        "cell.dateRange": _withCtx(({item, column}) => [
          _createElementVNode("span", null, _toDisplayString(item.startMonth) + " to " + _toDisplayString(item.endMonth), 1)
        ]),
        "cell.incidents-count": _withCtx(({item, column}) => [
          (item.universeSize)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createTextVNode(_toDisplayString(item.incidentsCount) + " (of " + _toDisplayString(item.universeSize) + " found) ", 1),
                (item.previouslySelectedCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, " – " + _toDisplayString(item.previouslySelectedCount) + " previously selected", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        "cell.status": _withCtx(({item, column}) => [
          _createElementVNode("span", null, _toDisplayString(item.status), 1),
          (item.comment)
            ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_3, null, 512)), [
                [_directive_tooltip, item.comment]
              ])
            : _createCommentVNode("", true)
        ]),
        "cell.sampleSize": _withCtx(({item, column}) => [
          (item.sampleSize)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.sampleSize), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createTextVNode(_toDisplayString(item.percentUniverse) + "% ", 1),
                (item.percentUniverseMinCount && item.percentUniverseMaxCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(item.percentUniverseMinCount) + "-" + _toDisplayString(item.percentUniverseMaxCount) + " incidents)", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(item.percentUniverseMaxCount) + " incidents max)", 1))
              ]))
        ]),
        "cell.actions": _withCtx(({item}) => [
          (canRunJob.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ($event: any) => (runJob(item.id)),
                type: "button",
                class: "btn btn-sm me-2 btn-primary"
              }, " Run ", 8, _hoisted_8))
            : _createCommentVNode("", true),
          (canDelete(item))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: ($event: any) => (deleteJob(item.id)),
                type: "button",
                class: "btn btn-sm btn-danger"
              }, " Delete ", 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("span", _hoisted_10))
        ]),
        _: 1
      }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
    ]),
    _createVNode(_unref(FormModal), {
      title: "Select Incidents",
      modelValue: isShowCreateEditor.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isShowCreateEditor).value = $event)),
      onSubmit: createJob,
      loading: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", _hoisted_11, [
          _cache[21] || (_cache[21] = _createElementVNode("legend", { class: "reset" }, "Specify Incident Universe", -1)),
          _createElementVNode("div", _hoisted_12, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-form-label col-sm-3" }, "Date Range:", -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    for: "startMonth",
                    class: "col-form-label"
                  }, "Start Date:", -1)),
                  _createVNode(_unref(BDatePicker), {
                    name: "startMonth",
                    "month-picker": true,
                    error: _unref(errors).startMonth,
                    modelValue: startMonth.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startMonth).value = $event))
                  }, null, 8, ["error", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    for: "endMonth",
                    class: "col-form-label"
                  }, "End Date:", -1)),
                  _createVNode(_unref(BDatePicker), {
                    "month-picker": true,
                    name: "endMonth",
                    error: _unref(errors).endMonth,
                    modelValue: endMonth.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endMonth).value = $event))
                  }, null, 8, ["error", "modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "form-label col-sm-3" }, "Incident Types:", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "A",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((auditJob.value.incidentTypes) = $event)),
                        id: "groupA"
                      }, null, 512), [
                        [_vModelCheckbox, auditJob.value.incidentTypes]
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "groupA"
                      }, " Group A ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "B",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((auditJob.value.incidentTypes) = $event)),
                        id: "groupB"
                      }, null, 512), [
                        [_vModelCheckbox, auditJob.value.incidentTypes]
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "groupB"
                      }, " Group B ", -1))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-sm-3" }, [
                _createElementVNode("label", {
                  for: "offenseTypes",
                  class: "col-form-label d-block"
                }, "Offense(s):"),
                _createElementVNode("small", { id: "offenseTypesHelp" }, "Select one or more offenses, or make no selection for all")
              ], -1)),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("select", {
                  id: "offenseTypes",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((auditJob.value.offenseTypes) = $event)),
                  multiple: "",
                  disabled: auditJob.value.incidentTypes.length == 0,
                  class: "form-select",
                  "aria-describedby": "offenseTypesHelp"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offenseStore).items, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.OffenseCode,
                      value: item.OffenseCode
                    }, _toDisplayString(item.OffenseLabel), 9, _hoisted_28))
                  }), 128))
                ], 8, _hoisted_27), [
                  [_vModelSelect, auditJob.value.offenseTypes]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("fieldset", null, [
          _cache[27] || (_cache[27] = _createElementVNode("legend", { class: "reset" }, "Random Selection from Universe", -1)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "measureType",
                  id: "measureTypeNumber",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((auditJob.value.measureType) = $event)),
                  value: 0
                }, null, 512), [
                  [_vModelRadio, auditJob.value.measureType]
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "measureTypeNumber"
                }, " Fixed count of incidents: ", -1))
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(TextInput, {
                  modelValue: auditJob.value.sampleSize,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((auditJob.value.sampleSize) = $event)),
                  "aria-label": "Sample Size",
                  name: "sampleSize",
                  min: 0,
                  type: "number",
                  disabled: auditJob.value.measureType != 0,
                  id: "sampleSize",
                  class: "form-control",
                  error: _unref(errors).sampleSize
                }, null, 8, ["modelValue", "disabled", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "measureType",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((auditJob.value.measureType) = $event)),
                    value: 1,
                    id: "measureTypePercent"
                  }, null, 512), [
                    [_vModelRadio, auditJob.value.measureType]
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "measureTypePercent"
                  }, " Percent of universe: ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(TextInput, {
                    modelValue: auditJob.value.percentUniverse,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((auditJob.value.percentUniverse) = $event)),
                    "aria-label": "Percent of universe",
                    name: "percentUniverse",
                    type: "number",
                    min: 0,
                    id: "percentUniverse",
                    class: "form-control",
                    disabled: auditJob.value.measureType != 1,
                    error: _unref(errors).percentUniverse
                  }, {
                    append: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("span", { class: "input-group-text" }, "%", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "error"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-sm-3 text-end" }, [
                _createElementVNode("label", {
                  for: "percentUniverseMinCount",
                  class: "col-form-label"
                }, "Min Count:")
              ], -1)),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(TextInput, {
                  type: "number",
                  min: 0,
                  modelValue: auditJob.value.percentUniverseMinCount,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((auditJob.value.percentUniverseMinCount) = $event)),
                  id: "percentUniverseMinCount",
                  disabled: auditJob.value.measureType != 1,
                  class: "form-control",
                  error: _unref(errors).percentUniverseMinCount
                }, null, 8, ["modelValue", "disabled", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-sm-3 text-end" }, [
                _createElementVNode("label", {
                  for: "percentUniverseMaxCount",
                  class: "col-form-label"
                }, "Max Count:")
              ], -1)),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(TextInput, {
                  type: "number",
                  modelValue: auditJob.value.percentUniverseMaxCount,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((auditJob.value.percentUniverseMaxCount) = $event)),
                  disabled: auditJob.value.measureType != 1,
                  id: "percentUniverseMaxCount",
                  class: "form-control",
                  error: _unref(errors).percentUniverseMaxCount
                }, null, 8, ["modelValue", "disabled", "error"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"])
  ], 64))
}
}

})